import Initializer from './initializer';

Initializer.render();
